export default "__VITE_ASSET__0lxCtwxC__"